<template>

  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>
  <div class="cell small-12">
    <h1>Scheme Reference</h1>
    <p>To help us set up your pension correctly, we need to know your scheme reference.</p>
    <p>This is a unique code or name given to your pension scheme by your pension provider. It helps identify the scheme when sending contributions and communications.</p>
    <p>You can usually find it on your pension setup documents or in your online pension account.</p>   
  </div>  
    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <input 
              type="text" 
              id="schemeReference" 
              name="schemeReference" 
              placeholder="" 
              v-model="formData.schemeReference" 
              required
              maxlength="25"
              pattern="[A-Za-z0-9]{25}"
              @input="formData.schemeReference = formData.schemeReference.toUpperCase()"
            />

      </form>
    </div>  

</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})

const validateStep = () => {

  error.value = [];

  const schemeReference = props.formData.schemeReference || '';
  if (!/^[A-Za-z0-9]{1,25}$/.test(schemeReference)) {
    error.value.push('Scheme Reference must be 1-25 characters, letters and numbers only.');
  }

  if (error.value.length > 0) return false;

  return true;
}




const executeStep = async () => {
  return true;
}




onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>